import { graphql } from "gql";

const INTERNAL_ADMIN_CREATE_USER_MUTATION = graphql(`
  mutation InternalAdminCreateUser(
    $organizationId: ID!
    $input: AdminCreateUserInput!
  ) {
    internalAdminCreateUser(organizationId: $organizationId, input: $input) {
      ...InternalAdminUser
    }
  }
`);

export default INTERNAL_ADMIN_CREATE_USER_MUTATION;
